const validateCustomerData = (customer, requiredFields = {}) => {
  const errors = {};

  const fullName = typeof customer.fullName === "string" ? customer.fullName.trim() : "";
  const email = typeof customer.email === "string" ? customer.email.trim() : "";
  const phone = typeof customer.phone === "string" ? customer.phone.trim() : "";

  if (requiredFields.name && !fullName) {
    errors.fullName = "Please enter your name.";
  } else if (requiredFields.name && fullName.length < 3) {
    errors.fullName = "Name must be at least 3 characters.";
  } else if (requiredFields.name && fullName.length > 100) {
    errors.fullName = "Name must be 100 characters or less.";
  }

  // Keep in sync with the backend: App\Helpers\CustomerContactValidation (payment-gateway-dashboard).
  const emailRegex = /^[A-Za-z0-9_%+-]+(?:\.[A-Za-z0-9_%+-]+)*@[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?)*\.[A-Za-z]{2,}$/;
  if (requiredFields.email && !email) {
    errors.email = "Please enter your email address.";
  } else if (requiredFields.email && email.length > 254) {
    errors.email = "Email must be 254 characters or less.";
  } else if (requiredFields.email && !emailRegex.test(email)) {
    errors.email = "Please enter a valid email address.";
  }

  // Keep in sync with the backend: App\Helpers\CustomerContactValidation::PHONE_REGEX.
  const phoneRegex = /^(\+62|0)8[1-9][0-9]{7,11}$/;
  if (requiredFields.phone && !phone) {
    errors.phone = "Please enter your phone number.";
  } else if (requiredFields.phone && !phoneRegex.test(phone)) {
    errors.phone = "Please enter a valid Indonesian phone number, starting with 08 or +62 (max 15 digits).";
  }

  return errors;
};

export default validateCustomerData;
